"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InvitationDetailsComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _InvitationDetailsAddress = _interopRequireDefault(require("./InvitationDetailsAddress"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    details: {
      marginTop: spacing(2),
      borderTopWidth: 1,
      borderTopStyle: 'solid',
      borderTopColor: palette.divider,
      padding: spacing(2),
      paddingLeft: 0
    },
    row: {
      marginTop: spacing(2)
    },
    firstRow: {
      marginTop: 0
    },
    title: {
      width: 70
    }
  };
});

var InvitationDetailsComponent = function InvitationDetailsComponent(_ref2) {
  var contactAddress = _ref2.contactAddress;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: classes.details
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    className: (0, _classnames.default)(classes.row, classes.firstRow)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Inactive', classes.title)
  }, "Shipping to:"), /*#__PURE__*/_react.default.createElement(_InvitationDetailsAddress.default, {
    address: contactAddress
  })));
};

exports.InvitationDetailsComponent = InvitationDetailsComponent;
InvitationDetailsComponent.propTypes = {
  contactAddress: _propTypes.default.shape({
    address_line_1: _propTypes.default.string,
    address_line_2: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    zip: _propTypes.default.string
  }).isRequired
};
var _default = InvitationDetailsComponent;
exports.default = _default;